module.exports = __webpack_public_path__ + "img/tag-background-icon.e83cade7.svg";